import { configureStore } from '@reduxjs/toolkit'
import loginInstruction from "../auth-reducer/slice";
import authReducer from '../auth-reducer/auth-reducer';

export const Store = configureStore({
  reducer: {
    instruction: loginInstruction,
    auth: authReducer,

  },
})